import React from 'react';
import {withRouter} from 'react-router-dom';
import ScreenComponent from "../../components/screenComponent";
import {Delete, Get, Post} from "../../components/request";
import screens from "../../screens";
import {Button, Form} from "react-bootstrap";
import FormGroup from "../../components/formGroup";
import MyFile from "../../components/myFile";
import DivTable from "../../components/divTable";
import {faTrashAlt} from "@fortawesome/pro-solid-svg-icons";
import MyCard from "../../components/myCard";

class DecretInclusif extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            decret: null,
            button: 'save',
            documents: null,
            isSaving : false
        }
    }


    async componentDidMount() {
        super.componentDidMount();

        let {body} = await Get(`/v1/extranet/student/${screens.DecretInclusif}`);
        let decret = body;

        ({body} = await Get(`/v1/extranet/student/${screens.DecretInclusif}01`));

        this.setState({
            decret: decret,
            documents: body
        });
    }

    async save(event) {
        event.preventDefault();
        event.stopPropagation();

        if(this.state.isSaving) {
            return;
        }

        // State used to avoid sending the request multiple times
        this.setState({
            isSaving: true
        });

        let data = new FormData();

        if (this.state.decret && this.state.decret.EtudiantDecretInclusif) {
            data = new FormData(event.currentTarget);
            data.append("DemandeDecretInclusifID", this.state.decret.DemandeDecretInclusifID);
        } else {
            data.append("DemandeDecretInclusifID", -1);
        }

        data.append("EtudiantID", this.state.decret.EtudiantID);
        data.append("action", this.state.button);

        let result = Object.fromEntries(Object.entries(Object.fromEntries(data)).map(([key, val]) => [key, /^-?\d+$/.test(val) ? Number(val) : val]));

        await Post(`/v1/extranet/student/${screens.DecretInclusif}`, result, "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Une demande est déjà en cours"});
        this.setState({
            isSaving: false
        });
        this.componentDidMount();
    }

    async saveFile(fileID) {
        await Post(`/v1/extranet/student/${screens.DecretInclusif}01`, {
            DocumentID: fileID,
            DemandeDecretInclusifID: this.state.decret.DemandeDecretInclusifID
        }, "Sauvegarde du fichier en cours..", {render: "Annexe ajoutée !"}, {render: "Erreur lors de la sauvegarde de l'annexe"});
        this.componentDidMount();
    }

    async deleteFile(fileID) {
        await Delete(`/v1/delete/${fileID}/${screens.DecretInclusif}01`);
        this.componentDidMount();
    }

    renderOpen() {
        return (
            <>
                <p>
                    En ouvrant un dossier, j'indique avoir pris connaissance des informations liées à l'enseignement
                    inclusif reprises sur <a target={"_blank"} href={"https://ichec.be"}>https://ichec.be</a>
                </p>
                <br/>
                <p style={{textAlign: "center"}}>
                    <Button variant={"primary"} size={"lg"} onClick={this.save.bind(this)}>Créer mon dossier
                        enseignement inclusif</Button>
                </p>
            </>
        )
    }

    renderDocuments() {
        return (
            <MyCard header={"Document(s) lié(s) au dossier"}
                    body={
                        <>
                            <p>
                                <b>Seul le format PDF est accepté et une taille maximum de 8Mo. </b><br/>
                            </p>
                            <MyFile label={"Annexer un fichier"}
                                    name={"DemandeDecretInclusifDocumentID"}
                                    accept={"application/pdf"}
                                    maxSizeMB={8}
                                    onChange={(id) => this.saveFile(id)}
                            />
                            {
                                this.state.documents != null && this.state.documents.length > 0
                                    ? <DivTable columns={{
                                        "Nom du document": "DocumentName",
                                        "Date de téléchargement": (item) => {
                                            return new Date(item.DemandeDecretInclusifDocumentDate).toLocaleString();
                                        }
                                    }}
                                                actions={[{
                                                    onClick: id => this.deleteFile(id),
                                                    icon: faTrashAlt, title: "Supprimer"
                                                }]}
                                                array={this.state.documents}/>
                                    : ""
                            }
                        </>
                    }
            />
        );
    }

    renderDetails() {
        return (
            <Form noValidate onSubmit={this.save.bind(this)}>
                <h5>Situation à l'origine de la demande</h5>
                <FormGroup as={"textarea"}
                           defaultValue={this.state.decret.DemandeDecretInclusifDiagnostique}
                           label={"Diagnostique"}
                           name={"DemandeDecretInclusifDiagnostique"}/>
                <FormGroup as={"textarea"}
                           defaultValue={this.state.decret.DemandeDecretInclusifSpecialiste}
                           label={"Coordonnées du/des spécialiste(s)"}
                           name={"DemandeDecretInclusifSpecialiste"}/>
                <FormGroup as={"textarea"}
                           defaultValue={this.state.decret.DemandeDecretInclusifDifficultes}
                           label={"Difficultés rencontrées"}
                           name={"DemandeDecretInclusifDifficultes"}/>
                <FormGroup as={"textarea"}
                           defaultValue={this.state.decret.DemandeDecretInclusifOrganisme}
                           label={"Reconnaissance par un organisme agréé"}
                           name={"DemandeDecretInclusifOrganisme"}/>
                <FormGroup as={"textarea"}
                           defaultValue={this.state.decret.DemandeDecretInclusifAmenagements}
                           label={"Aménagements et modalités d’accompagnement souhaités"}
                           name={"DemandeDecretInclusifAmenagements"}/>
                <FormGroup as={"textarea"}
                           defaultValue={this.state.decret.DemandeDecretInclusifAccompagnement}
                           label={"Accompagnement de la part d'un étudiant / membre du personnel"}
                           name={"DemandeDecretInclusifAccompagnement"}/>
                {this.renderDocuments()}
                <div className={"d-flex mt-4"}>
                    <Button type="submit" onClick={() => this.state.button = 'save'} variant="primary" size={"lg"}
                            block>
                        Sauvegarder
                    </Button>
                    <Button type="submit" onClick={() => this.state.button = 'submit'} variant="success" size={"lg"}
                            block style={{margin: 0, marginLeft: 4}}>
                        Soumettre {this.state.decret.DemandeDecretInclusifDateDerniereSoumission && "les modifications"}
                    </Button>
                </div>

                {this.state.decret.DemandeDecretInclusifDateDerniereSoumission &&
                <p>
                    <b>Date de dernière
                        soumission: </b> {new Date(this.state.decret.DemandeDecretInclusifDateDerniereSoumission).toLocaleString()}
                </p>
                }
            </Form>
        )
    }

    render() {

        return (
            <section>
                {this.state.decret && this.state.decret.EtudiantDecretInclusif ? this.renderDetails() : this.renderOpen()}
            </section>
        );
    }
}

export default withRouter(DecretInclusif);